import * as React from 'react';
import { LoaderProps } from '../../components/loader';
import { bodyLock, bodyUnlock } from '../../../../Static/javascript/Ace2/helpers/bodyLock';

const LoaderView: React.StatelessComponent<LoaderProps> = props => {

    if (!props.isProcessing) {
        bodyUnlock('');
        return null;
    } else {
        bodyLock()
    }

    return (
        props.text.loaderImageUrl != "" ?
            <div className="ace-loader">
                <p className="visually-hidden" aria-live="polite">
                    {props.text.loadingLabel ? props.text.loadingLabel : "Loading...please wait"}
                </p>
                <div className="ace-loader-image-container" role="presentation">
                    <img className="ace-loader-image" src={props.text.loaderImageUrl}/>
                </div>
            </div>
            :
            <div className="ace-loader" role="presentation">
                <div className="ace-loader-spinner">
                    <div></div><div></div><div></div><div></div>
                </div>
            </div>
    )
}

export default LoaderView;